const QUERIES = {
  DesktopOrLaptop: {minWidth: 1224},
  iPadOrTablet: {maxWidth: 1224, minWidth: 850},
  mobile: {maxWidth: 850},
};

export default QUERIES;
